import React, {Component} from "react";
import SimpleTextArea from "../../../../../../modules/simpleTextArea";

class tabKeterangan extends Component {
    getValue = (key) => {
        const {tab} = this.props
        return this.props.data?.[tab]?.[key] || null;
    }

    setValue = (tab, name, value) => {
        this.props.onSetState((prevState) => ({
            ...prevState,
            data : {
                ...prevState.data,
                [tab] : {
                    ...prevState.data[tab],
                    [name] : value
                }
            }
        }))
    }

    render() {
        const {tab} = this.props;
        return (
            <>
                <div className="grid grid-2x gap-20px grid-mobile-none">
                    <div id="grid-1">
                        <SimpleTextArea
                            id="input_text_keterangan"
                            name="note"
                            label="Keterangan"
                            readOnly={!this.props.state.isEditable}
                            value={this.getValue("note")}
                            onChange={({target}) => this.setValue(tab, target.name, target.value)}
                        />
                    </div>
                    <div id="grid-2"></div>
                </div>
            </>
        )
    }
}

export default tabKeterangan;